<template>
  <el-menu
      :default-active="this.$store.state.menus.editableTabsValue"
      class="el-menu-vertical-demo"
      text-color="#fff"
      background-color="#143f6b"
      active-text-color="#ffd04b">
    <!-- 首页（固定显示） -->
    <el-menu-item index="Index" @click="handleMenuClick({name: 'Index', title: '首页', path: '/index'})">
      <template slot="title">
        <i class="el-icon-s-home"></i>
        <span slot="title">首页</span>
      </template>
    </el-menu-item>
    
    <!-- 基于白名单的动态菜单 -->
    <template v-for="menu in whiteListMenus">
      <!-- 单级菜单 -->
      <el-menu-item v-if="!menu.children || menu.children.length === 0" :key="'menu-' + menu.name" :index="menu.name" @click="handleMenuClick({name: menu.name, title: menu.title, path: menu.path})">
        <template slot="title">
          <i :class="menu.icon || getDefaultIcon(menu.name)"></i>
          <span slot="title">{{ menu.title }}</span>
        </template>
      </el-menu-item>
      
      <!-- 多级菜单 -->
      <el-submenu v-else :key="'submenu-' + menu.name" :index="menu.name">
        <template slot="title">
          <i :class="menu.icon || getDefaultIcon(menu.name)"></i>
          <span>{{ menu.title }}</span>
        </template>
        <el-menu-item v-for="child in menu.children" :key="child.name" :index="child.name" @click="handleMenuClick({name: child.name, title: child.title, path: child.path})">
          <span slot="title">{{ child.title }}</span>
        </el-menu-item>
      </el-submenu>
    </template>
    
    <!-- 动态菜单（从API加载） -->
    <menu-item v-for="menu in apiMenuList" :key="menu.id" :menu="menu" @select-menu="selectMenu" />
  </el-menu>
</template>

<script>
import { get } from '@/api/api'
import MenuItem from '@/components/MenuItem.vue'

export default {
  name: "SideMenu",
  components: {
    MenuItem
  },
  data() {
    return {
      apiMenuList: [], // 只存储从API加载的动态菜单
      whiteListMenus: [] // 基于白名单的菜单
    }
  },
  created() {
    this.loadWhiteListMenus()
    this.ensureMenusLoaded()
    // 初始化时同步当前路由状态
    this.syncMenuActiveState()
  },
  watch: {
    // 监听路由变化，自动更新菜单选中状态
    '$route'(to, from) {
      this.syncMenuActiveState()
    }
  },
  methods: {
    // 加载白名单菜单
    loadWhiteListMenus() {
      // 路由白名单配置
      const whiteList = ['/login']
      
      // 从路由配置中获取菜单数据
      const allRoutes = this.$router.options.routes
      const homeRoute = allRoutes.find(route => route.path === '/')
      
      if (homeRoute && homeRoute.children) {
        this.whiteListMenus = homeRoute.children.filter(route => {
          // 过滤出在白名单中的路由（排除首页和登录页）
          return whiteList.some(whitePath => {
            return route.path === whitePath || route.path.startsWith(whitePath + '/')
          }) && route.path !== '/index' && route.title
        }).map(route => ({
          name: route.name,
          title: route.title,
          path: route.path,
          icon: route.icon,
          children: route.children || []
        }))
      }
    },
    
    // 获取默认图标
    getDefaultIcon(menuName) {
      const iconMap = {
        'patientManagement': 'el-icon-user',
        'prescriptionManagement': 'el-icon-document',
        'systemManagement': 'el-icon-setting',
        'outpatientService': 'el-icon-s-order'
      }
      return iconMap[menuName] || 'el-icon-menu'
    },
    
    async ensureMenusLoaded() {
      try {
        const user = sessionStorage.getItem('User')
        if (!user) return

        // 统一向全局 store 请求（只会请求一次），然后本地过滤/排序
        const menuList = await this.$store.dispatch('loadMenusOnce')

        const dynamicMenus = (menuList || []).filter(menu => {
          const whiteList = ['patientManagement', 'prescriptionManagement', 'systemManagement']
          return menu.isShow === 1 && !whiteList.includes(menu.name)
        })
        console.log(this.apiMenuList)
        this.apiMenuList = this.sortMenus(dynamicMenus)
      } catch (error) {
        console.log('加载动态菜单失败:', error)
      }
    },
    // 递归排序菜单
    sortMenus(menus) {
      if (!menus || !Array.isArray(menus)) return []
      
      const sortedMenus = menus.sort((a, b) => (a.sort || 0) - (b.sort || 0))
      
      return sortedMenus.map(menu => {
        if (menu.children && menu.children.length > 0) {
          menu.children = this.sortMenus(menu.children)
        }
        return menu
      })
    },
    selectMenu(item) {
      // 使用统一的 upsertTab，保证已存在则激活，未存在则新增
      const tab = { name: item.name, title: item.title, path: item.path }
      this.$store.commit('upsertTab', tab)

      // 路由跳转（避免重复导航报错）
      if (item.path && this.$route.path !== item.path) {
        console.log('routerItem', item)
        this.$router.push(item.path).catch(() => {})
      }
    },
    
    // 处理菜单点击事件
    handleMenuClick(menuItem) {
      // 统一使用selectMenu方法处理
      this.selectMenu({
        name: menuItem.name,
        title: menuItem.title,
        path: menuItem.path
      })
    },
    
    // 同步菜单选中状态
    syncMenuActiveState() {
      const currentRoute = this.$route
      if (!currentRoute) return
      
      // 根据当前路由名称更新store中的editableTabsValue
      const routeName = currentRoute.name
      if (routeName && routeName !== this.$store.state.menus.editableTabsValue) {
        // 查找对应的菜单项标题
        let menuTitle = this.getMenuTitleByRouteName(routeName)
        
        if (menuTitle) {
          // 将当前路由同步为tab（包含path，确保再次点击侧边菜单时能正确匹配、激活）
          this.$store.commit('upsertTab', {
            name: routeName,
            title: menuTitle,
            path: currentRoute.path
          })
        }
      }
    },
    
    // 根据路由名称获取菜单标题
    getMenuTitleByRouteName(routeName) {
      // 检查白名单菜单
      for (let menu of this.whiteListMenus) {
        if (menu.name === routeName) {
          return menu.title
        }
        // 检查子菜单
        if (menu.children) {
          for (let child of menu.children) {
            if (child.name === routeName) {
              return child.title
            }
          }
        }
      }
      
      // 检查API动态菜单
      for (let menu of this.apiMenuList) {
        if (menu.name === routeName) {
          return menu.menuName
        }
        // 检查子菜单
        if (menu.children) {
          for (let child of menu.children) {
            if (child.name === routeName) {
              return child.menuName
            }
          }
        }
      }
      
      // 检查固定菜单
      if (routeName === 'Index') {
        return '首页'
      }
      if (routeName === 'UserCenter') {
        return '个人中心'
      }
      
      return null
    }
  }
}
</script>

<style scoped>
.el-menu-vertical-demo {
  height: calc(100vh - 70px);
  text-align: left;
  width: 100%;
  background: var(--sideMenun-bg-color);
}

a {
  text-decoration: none;
}

.el-menu {
  border: 0;
  background: var(--sideMenun-bg-color) !important;
}
.el-menu >>> a {
 text-decoration: none;
}
.el-menu >>> .el-menu-item {
  background-color: transparent !important;
  color: var(--sideMenun-text-color) !important;
  transition: all 0.3s ease;
}

.el-menu >>> .el-menu-item:hover {
  background-color: var(--sideMenun-bg-color-hover) !important;
  color: var(--sideMenun-text-color-hover) !important;
}

.el-menu >>> .el-menu-item.is-active {
  background-color: var(--primary-color) !important;
  color: var(--primary-text-color) !important;
  font-weight: bold;
}

.el-menu >>> .el-submenu__title {
  background-color: transparent !important;
  color: var(--sideMenun-text-color) !important;
  border-left: 3px solid transparent;
  transition: all 0.3s ease;
  font-weight: 700;
}

.el-menu >>> .el-submenu__title:hover {
  background-color: var(--sideMenun-bg-color-hover) !important;
  color: var(--sideMenun-text-color-hover) !important;
}

.el-menu >>> .el-submenu.is-active > .el-submenu__title {
  color: var(--sideMenun-text-color) !important;
}
.el-menu >>> .el-submenu.is-active > .el-submenu__title:hover {
  color: var(--sideMenun-text-color-hover) !important;
}

.el-menu >>> .el-submenu .el-menu {
  background-color: transparent !important;
}

.el-menu >>> .menu-children {
  color: var(--sideMenun-text-color) !important;
  padding-left: 40px !important;
  text-decoration: none;
}

.el-menu >>> .menu-children:hover {
  background-color: var(--sideMenun-bg-color-hover) !important;
  color: var(--sideMenun-text-color-hover) !important;
}

.el-menu >>> .menu-children.is-active {
  background-color: var(--sideMenun-bg-color-active) !important;
  color: var(--sideMenun-text-color-active) !important;
  font-weight: bold;
}
</style>
